<template>
  <div id="app-modal" class="modal-mask">
    <div class="modal-wrapper" @click="keyBack">
      <div :class="'modal-container ' + 'modal-container-' + $store.getters.platform" v-on:click.stop>

        <div class="modal-header">
          <slot name="header"></slot>
        </div>

        <div class="modal-body">
          <slot name="body"></slot>
        </div>

        <!-- <div class="divider"></div> -->

        <div class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SpatialNavigation from 'js-spatial-navigation'
import Bus from '@/components/ControlBus'

export default {
  name: 'ModalCountries',
  created: function () {
    SpatialNavigation.pause()
  },
  mounted: function () {
    setTimeout(() => {
      this.SN = SpatialNavigation.add({selector: '#app-modal .modal-focusable, #app-modal  .wrapper-features-focusable', restrict: 'self-only'})
      SpatialNavigation.makeFocusable(this.SN)

      SpatialNavigation.focus(this.SN)
      SpatialNavigation.resume()

      // control keys
      Bus.$on('key-back', this.keyBack)
    })
  },
  methods: {
    keyBack: function () {
      if (this.SN) SpatialNavigation.remove(this.SN)
      this.$emit('close', {action: false})
    },
    close (event) {
      if (this.SN) SpatialNavigation.remove(this.SN)
      this.$emit('close', {action: true})
    }
  },
  beforeDestroy: function () {
    Bus.$off('key-back', this.keyBack)
    if (this.SN) SpatialNavigation.remove(this.SN)
  }
}
</script>

<style lang="sass" scoped>
.modal-mask
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  user-select: none
  // transition: opacity .3s ease;
  word-wrap: break-word;
  // pointer-events: none;

  .modal-wrapper
    display: table-cell;
    vertical-align: middle;

    .modal-container-tv
      width: 90vw!important

    .modal-container
      position: relative
      width: 45vw;
      margin: 0px auto;
      border-radius: 2px;
      // box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      // transition: all .3s ease;
      // margin-bottom: 45vh // desplazamos hacia arriba por teclado
      pointer-events: all;

    .divider
      margin: 1rem 0 1rem 0

    .modal-header
      font-size: 2rem
      text-transform: uppercase
      background-color: rgba(0, 0, 0, .7);
      padding: 2rem 0rem;
      display: flex;
      align-items: center
      border-top-left-radius: 1rem;
      border-top-right-radius: 1rem;
      border-top: 1px solid #fff;
      border-left: 1px solid #fff;
      border-right: 1px solid #fff;

      img
        width: 12rem
        margin: auto

    .modal-body
      font-size: 1.4rem
      // margin: 20px 0
      padding: 20px;
      text-align: center;
      background-color: rgba(255, 255, 255, .7);

    .modal-footer
      text-align: right
      padding: 1rem;
      background-color: rgba(255, 255, 255, .7);
      border-bottom-left-radius: 1rem;
      border-bottom-right-radius: 1rem;
      border-bottom: 1px solid #fff;
      border-left: 1px solid #fff;
      border-right: 1px solid #fff;

    .modal-footer
      text-align: right

@media screen and (max-width: 576px)
  .modal-container
    width: 95vw!important

</style>



// WEBPACK FOOTER //
// src/components/ModalCountries.vue